<template lang="html">
  <section class="relative z-10 mb-8">
    <!-- <filter-segment
      @segmentUpdated="handleSegmentUpdate"
      :segments="segments"
    ></filter-segment> -->

    <div
      class="flex flex-col sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12 my-5"
    >
      <filter-item
        v-for="item in data"
        :key="item.name"
        :item="item"
        :filtersData="data"
        @filtersUpdated="handleFilterUpdate"
      ></filter-item>
    </div>
  </section>
</template>

<script>
import filterData from '../data/filters';
import Filter from './Filter.vue';
import DataEncoder from '../helper/encoder';
import FilterSegment from './FilterSegment.vue';

export default {
  name: 'Filters',
  props: ['highestPrice', 'highestMileage', 'segments', 'modelsFilter'],
  components: {
    'filter-item': Filter,
    'filter-segment': FilterSegment,
  },
  data: function () {
    return {
      filters: 'Filtering should be done by model, fuel type, price range',
      data: [this.modelsFilter].concat(filterData),
      activeFilters: [],
    };
  },
  methods: {
    handleSegmentUpdate(payload) {
      this.$emit('segmentUpdated', payload);
    },
    handleFilterUpdate(payload) {
      let newFilters = [];
      let found = false;
      this.activeFilters.map((item) => {
        if (item.name === payload.name) {
          newFilters.push(payload);
          found = true;
        } else {
          newFilters.push(item);
        }
      });
      if (!found) {
        newFilters.push(payload);
      }
      this.activeFilters = newFilters;
    },
  },

  watch: {
    activeFilters: {
      handler: function (newVal) {
        const encoder = new DataEncoder();
        const search = encoder.encode({ f: newVal });
        const newUrl = window.location.href.split('?')[0] + `?${search}`;
        history.replaceState(null, null, newUrl);

        this.$emit('filtersUpdated', newVal);
      },
      deep: true,
    },
    highestPrice: function (newVal) {
      this.data.map((item) => {
        if (item.name === 'price') item.options = [0, newVal];
      });
    },
    highestMileage: function (newVal) {
      this.data.map((item) => {
        if (item.name === 'mileage') item.options = [0, newVal];
      });
    },
  },
};
</script>
